"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _webClientStore = require("web-client-store");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
let {
  Session
} = _webClientStore.WebClientStore;
let _site = window.location.hostname;
// console.log('site', _site);
let _isProd = _site.startsWith('chits.') || _site.startsWith('prod-chits.');
let _isPreview = _site.startsWith('preview-chits.');
let _isDev = _site.startsWith('dev-chits.');
let api = process.env.REACT_APP_API_HOST;
if (_isProd) {
  api = 'https://us-central1-pfm-api.cloudfunctions.net/chit';
} else if (_isPreview || _isDev) {
  api = 'https://us-central1-perfinmngr.cloudfunctions.net/chit';
}
if (!api) {
  api = "http://".concat(_site, ":5002");
}
api += '/api/v/1';
// console.log('api', api);

const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
function getFormattedDate(date) {
  let prefomattedDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let hideYear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const day = date.getDate();
  const month = MONTH_NAMES[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours();
  let minutes = date.getMinutes();
  if (minutes < 10) {
    // Adding leading zero to minutes
    minutes = "0".concat(minutes);
  }
  if (prefomattedDate) {
    // Today at 10:20
    // Yesterday at 10:20
    return "".concat(prefomattedDate, " at ").concat(hours, ":").concat(minutes);
  }
  if (hideYear) {
    // 10. January at 10:20
    return "".concat(day, " ").concat(month, " at ").concat(hours, ":").concat(minutes);
  }

  // 10. January 2017. at 10:20
  return "".concat(day, " ").concat(month, " ").concat(year, ". at ").concat(hours, ":").concat(minutes);
}
const Constants = {
  EMPTY_CSV_HEADERS: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
  GRID_ROW_MIN_LENGTH: 4,
  GRID_ROW_MAX_LENGTH: 300,
  FREE_USER_ACCOUNTS_QUOTA: 20,
  FREE_USER_TRANS_QUOTA: 10000,
  FREE_USER_RECEIPT_SIZE_QUOTA: 100 * 1024,
  // In KBs
  FREE_USER_RECEIPT_COUNT_QUOTA: 100,
  FREE_USER_RECEIPT_UPLOAD_SIZE_LIMIT: 2 * 1024 * 1024,
  // 5MB In bytes,
  CHAR_TO_PIXEL_MULTIPLIER: 12,
  COLORs: {
    ADDAM: 'transparent',
    JAAJI: '#F48860',
    SABBU: '#5AAAF1',
    VANKAYA_250: '#DFD8F5',
    KATUKA_500: '#333333',
    BOODIDA: '#cfd1cf'
  },
  /* "రంగులు": {
      "దర్పనం": 'transparent',
      "జాజి": '#F48860',
      "సబ్బు": '#5AAAF1',
      "వంకాయ_250": '#DFD8F5',
      "కాటుక_500": '#333333'
  }, */
  URLs: {
    BASE_URL: "".concat(api),
    ACCOUNTS: "".concat(api, "/accounts"),
    SUBSCRIBERS: "".concat(api, "/subscribers"),
    ACCOUNT_MEMBERS: "".concat(api, "/members"),
    ACCOUNT_SUBSCRIBERS: "".concat(api, "/subscribers"),
    ACCOUNT_RECEIPTS: "".concat(api, "/receipts"),
    ACCOUNT_SCHEDULE: "".concat(api, "/schedule"),
    TRANS: "".concat(api, "/transactions"),
    USERS: "".concat(api, "/users"),
    TRANS_OF_ACCOUNT: "".concat(api, "/transactions/account"),
    TRANS_OF_USER: "".concat(api, "/transactions/user"),
    AUTH: {
      LOGOUT: "".concat(api, "/auth/logout"),
      LOGIN: "".concat(api, "/auth/login"),
      REGISTER: "".concat(api, "/auth/register"),
      FORGOT: "".concat(api, "/auth/forgot"),
      RESET: "".concat(api, "/auth/reset"),
      TOKEN: "".concat(api, "/auth/token")
    },
    LIST_ITEMS: "".concat(api, "/listitems"),
    LIST_ITEMS_LIST: {
      BASE: "".concat(api, "/listitems/list"),
      CURRENCIES: "".concat(api, "/listitems/list/currencies"),
      ACCNT_TYPES: "".concat(api, "/listitems/list/chitfund_account_type"),
      LIST_MAJOR: "".concat(api, "/listitems/list/list_major")
    },
    LIST_ITEMS_AVAILABLE: "".concat(api, "/listitems/available"),
    SERVICE: "".concat(api, "/service"),
    TRAN_TYPES: "".concat(api, "/trantypes"),
    WIDGETS: "".concat(api, "/widgets"),
    RECEIPTS: "".concat(api, "/receipts"),
    STATEMENT: "".concat(api, "/statement"),
    HEALTH: "".concat(api, "/actuator/health")
  },
  COOKIE_KEYS: {
    SESSION: '__session'
  },
  LOCAL_KEYS: {
    REFRESH_TOKEN: 'refreshToken',
    ACTIVE_ACCOUNT_GRID_MODE: "LOCAL_KEY_ACTIVE_ACCOUNT_GRID_MODE",
    ACTIVE_SUBSCRIBER_GRID_MODE: "LOCAL_KEY_ACTIVE_SUBSCRIBER_GRID_MODE"
  },
  SESSION_KEYS: {
    ACTIVE_ACCOUNT: "SESSION_KEY_ACTIVE_ACCOUNT",
    ACTIVE_ACCOUNT_TYPE: "SESSION_KEY_ACTIVE_ACCOUNT_TYPE",
    ACTIVE_ACCOUNT_CURR: "SESSION_KEY_ACTIVE_ACCOUNT_CURR",
    ACTIVE_TRAN_TYPE: "SESSION_KEY_ACTIVE_TRAN_TYPE",
    ACTIVE_LIST_MAJOR: "SESSION_KEY_ACTIVE_LIST_MAJOR",
    CURRENCIES: "SESSION_KEY_CURRENCIES",
    ACCOUNT_TYPES: "SESSION_KEY_ACCOUNT_TYPES",
    LAST_LINK_ACCOUNT: "SESSION_KEY_LAST_LINK_ACCOUNT",
    USER_NAME: "SESSION_KEY_USER_NAME",
    USER_EMAIL: "SESSION_KEY_USER_EMAIL",
    USER_ID: "SESSION_KEY_USER_ID",
    USER_PREVILEGES: "SESSION_KEY_USER_PREVILEGES"
  },
  INDEXED_KEYS: {
    CURRENCIES: 'KEY_CURRENCIES',
    ACCT_TYPES: 'KEY_ACCOUNT_TYPES',
    PROFILE: 'KEY_PROFILE',
    ACCOUNTS: 'KEY_ACCOUNTS',
    SUBSCRIBERS: 'KEY_SUBSCRIBERS',
    TRAN_TYPES: 'KEY_TRAN_TYPES',
    USER_INFO: 'KEY_USER_INFO',
    ACCOUNT_YEARLY_TREND: 'KEY_ACCOUNT_YEARLY_TREND',
    ACCOUNT_TRANTYPE_SPLITS: 'KEY_ACCOUNT_TRANTYPE_SPLITS',
    TRAN_DASHBOARD: 'KEY_TRAN_DASHBOARD',
    ACCOUNT_SUBSCRIBERS: 'KEY_ACCOUNT_SUBSCRIBERS',
    ACCOUNT_TRANSACTIONS: 'KEY_ACCOUNT_TRANSACTIONS',
    ACCOUNT_TYPE_TRAN_TYPES: 'KEY_ACCOUNT_TYPE_TRAN_TYPES',
    ENTITY_RECEIPTS: 'KEY_ENTITY_RECEIPTS'
  },
  ACTIVE_ACCOUNT_GRID_MODES: {
    CARDS: 1,
    DARK: 2,
    LIGHT: 3
  },
  ACTIVE_SUBSCRIBER_GRID_MODES: {
    DARK: 2,
    LIGHT: 3
  },
  DEFAULT_ACCOUNT: {
    "_id": "unknown",
    "name": "Please Select An Account",
    "code": "unknown",
    /* TODO: make unknown a reserved word when adding a new account */
    "status": "ac",
    "chit_info": {
      chit_amount: 100000,
      chit_tenure: 20,
      chit_subscribers: 20,
      chit_term_amount: 5000,
      chit_term_fee: 1000,
      chit_start_on: '2021-08-20',
      chit_draw_date: 1,
      chit_due: 5,
      nextTerm: -1
    }
  },
  DEFAULT_ACCOUNT_SHOW_ALL: {
    "_id": "unknown",
    "name": "Show All Accounts",
    "code": "unknown",
    /* TODO: make unknown a reserved word when adding a new account */
    "status": "ac"
  },
  // cleanUpCurrency: (s) => {
  //     var expression = /^\$?\([\d,\.]*\)$/;
  //     s = s.trim().replace(',', '');
  //     //Check if it is in the proper format
  //     if(s.match(expression)){
  //         //It matched - strip out parentheses and append - at front      
  //         return parseFloat('-' + s.replace(/[\$\(\),]/g,'')) || 0;
  //     }
  //     else{
  //         return parseFloat(s) || 0;
  //     }   
  // },
  extractAmnt: s => {
    // console.log('extractAmnt(str):', str);
    if (s === undefined || s === '') return 0;
    let str = s.toString().trim();
    // var str = "$jhkj1,7s68.28.34";
    // console.log('>' + str, str.length);
    let val = '';
    for (let i = 0; i < str.length; i++) {
      let n = -1;
      // extract digit at this position
      try {
        n = parseInt(str[i]);
      } catch (ex) {}
      // if what extracted is finite, append to total string
      if (isFinite(n)) {
        if (!val.includes('-') && (str.substr(0, i).includes('-') || str.substr(0, i).includes('(') && str.includes(')'))) {
          val = '-';
        }
        val += n;
      } else if (str[i] === '.' && !val.includes('.')) {
        val += '.';
      }
    }
    // finally parse the string sequence as float
    try {
      val = parseFloat(val);
      val = parseFloat(parseInt(val * 100) / 100);
      val = val.toFixed(2);
    } catch (ex) {}
    // if is not rendered correctly; return 0;
    if (isNaN(val) || val === '') return 0;
    // console.log('value:' + val);
    return val;
  },
  getQuarter: d => {
    let d1 = new Date();
    try {
      if (!isNaN(new Date(d))) {
        d1 = new Date(d);
      }
    } catch (error) {}
    // console.log('d1:', d1);
    var q = [1, 2, 3, 4];
    var qtr = q[Math.floor(d1.getMonth() / 3)];
    var y = d1.getFullYear();
    return [y, qtr];
  },
  getQtrStr: d => Constants.getQuarter(d).join('Q'),
  SIDEBAR_ITEM_LIST: [
  /*{
      name: "Dashboard",
      path: '/dashboard',
      icon: 'nc-chart-pie-35',
      active: false
  },*/
  {
    name: "Accounts",
    path: '/accounts',
    icon: 'nc-bank',
    active: false
  }, {
    name: "Transactions",
    path: '/transactions',
    icon: 'nc-paper-2',
    active: false
  }, {
    name: "Subscribers",
    path: '/subscribers',
    icon: 'nc-badge',
    active: false
  }
  /* ,
   {
       name: "Widgets",
       path: '/widgets',
       icon: 'nc-chart-bar-32',
       active: false
   } ,
   {
       name: "Upload",
       path: '/upload',
       icon: 'nc-cloud-upload-94',
       active: false
   },
   {
       name: "User Profile",
       path: '/profile',
       icon: 'nc-circle-09',
       active: false
   },
   {
       name: "Logout",
       path: '/logout',
       icon: 'nc-tap-01',
       active: false
   },*/],
  timeAgo: dateParam => {
    if (!dateParam) {
      return null;
    }
    const date = typeof dateParam === 'object' ? dateParam : new Date(dateParam);
    const DAY_IN_MS = 86400000; // 24 * 60 * 60 * 1000
    const today = new Date();
    const yesterday = new Date(today - DAY_IN_MS);
    const seconds = Math.round((today - date) / 1000);
    const minutes = Math.round(seconds / 60);
    const isToday = today.toDateString() === date.toDateString();
    const isYesterday = yesterday.toDateString() === date.toDateString();
    const isThisYear = today.getFullYear() === date.getFullYear();
    if (seconds < 5) {
      return 'now';
    } else if (seconds < 60) {
      return "".concat(seconds, " seconds ago");
    } else if (seconds < 90) {
      return 'about a minute ago';
    } else if (minutes < 60) {
      return "".concat(minutes, " minutes ago");
    } else if (isToday) {
      return getFormattedDate(date, 'Today'); // Today at 10:20
    } else if (isYesterday) {
      return getFormattedDate(date, 'Yesterday'); // Yesterday at 10:20
    } else if (isThisYear) {
      return getFormattedDate(date, false, true); // 10. January at 10:20
    }
    return getFormattedDate(date); // 10. January 2017. at 10:20
  },
  getCurrencyLocale: function () {
    let curr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'USD';
    switch (curr.toUpperCase()) {
      case 'INR':
        return 'en-IN';
      case 'JPY':
        return 'ja-JP';
      case 'EUR':
        return 'de-DE';
      default:
        return 'en-US';
    }
  },
  toSimpleCurrency: function () {
    let amnt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.00;
    let curr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';
    let bal = Number(amnt);
    return bal.toLocaleString(Constants.getCurrencyLocale(curr));
  },
  toCurrency: function () {
    let amnt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.00;
    let curr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';
    let bal = Number(amnt);
    return bal.toLocaleString(Constants.getCurrencyLocale(curr), {
      style: 'currency',
      currency: curr
    });
  },
  toCurrencyES6: function () {
    let amnt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.00;
    let curr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';
    let bal = Number(amnt);
    return new Intl.NumberFormat(Constants.getCurrencyLocale(curr), {
      style: 'currency',
      currency: curr
    }).format(bal);
  },
  agGridComparatorDate: (filterLocalDateAtMidnight, cellValue) => {
    var dateAsString = cellValue;
    if (dateAsString == null) {
      return 0;
    }
    // var dateAsString = cellValue;
    // var dateParts = dateAsString.split('-');
    // var cellDate = new Date(Number(dateParts[0]), Number(dateParts[1]) - 1, Number(dateParts[2]));
    var cellDate = (0, _momentTimezone.default)(cellValue.substr(0, 10)).toDate();
    // console.log('a', moment(filterLocalDateAtMidnight).format('YYYY-MM-DD'))
    // console.log('b',moment(cellDate).format('YYYY-MM-DD'))
    if ((0, _momentTimezone.default)(filterLocalDateAtMidnight).format('YYYY-MM-DD') === (0, _momentTimezone.default)(cellDate).format('YYYY-MM-DD')) {
      return 0;
    }
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }
    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
  },
  getDomain: () => {
    let host = window.location.hostname;
    return host.includes('codecubers.lab') ? "http://".concat(host) : "https://".concat(host);
  },
  getAccountName: account => {
    let name = '';
    try {
      name = account.status === 'cl' ? '[Archive]-' : '';
      name += account.name;
      name += account.isAdmin ? ' (Admin)' : '';
      name += account.isEditor ? ' (Editor)' : '';
      name += account.isViewer ? ' (Viewer)' : '';
    } catch (error) {}
    return name;
  },
  secondsToDhmsLong: seconds => {
    seconds = Number(seconds);
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor(seconds % (3600 * 24) / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 60);
    var dDisplay = d > 0 ? d + (d === 1 ? " day, " : " days, ") : "";
    var hDisplay = h > 0 ? h + (h === 1 ? " hour, " : " hours, ") : "";
    var mDisplay = m > 0 ? m + (m === 1 ? " minute, " : " minutes, ") : "";
    var sDisplay = s > 0 ? s + (s === 1 ? " second" : " seconds") : "";
    return dDisplay + hDisplay + mDisplay + sDisplay;
  },
  secondsToDhms: seconds => {
    seconds = Number(seconds);
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor(seconds % (3600 * 24) / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 60);
    var dDisplay = d > 0 ? d + "D " : "";
    var hDisplay = h > 0 ? h + "H " : "";
    var mDisplay = m > 0 ? m + "M " : "";
    var sDisplay = s > 0 ? s + "S " : "";
    return dDisplay + hDisplay + mDisplay + sDisplay;
  },
  secondsToDhmsTime: seconds => {
    seconds = Number(seconds);
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor(seconds % (3600 * 24) / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 60);
    var dDisplay = d > 0 ? d + "Days " : "";
    var hDisplay = (h < 10 ? "0" : "") + h + ":";
    var mDisplay = (m < 10 ? "0" : "") + m + ":";
    var sDisplay = (s < 10 ? "0" : "") + s;
    return dDisplay + hDisplay + mDisplay + sDisplay;
  },
  /**
   * // formatBytes(bytes,decimals)
   *  formatBytes(1024);       // 1 KB
   *  formatBytes('1024');     // 1 KB
   *  formatBytes(1234);       // 1.21 KB
   *  formatBytes(1234, 3);    // 1.205 KB
   * @param {bytes} a 
   * @param {decimals} b 
   * @returns size in formated string
   */
  formatBytes: function (a) {
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    if (0 === a) return "0 Bytes";
    const c = 0 > b ? 0 : b,
      d = Math.floor(Math.log(a) / Math.log(1024));
    return parseFloat((a / Math.pow(1024, d)).toFixed(c)) + " " + ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d];
  },
  requestTranRefresh: ac => {
    if (!ac) {
      ac = Session.get(Constants.SESSION_KEYS.ACTIVE_ACCOUNT);
      if (!ac) return;
    }
    Session.set(ac + '_req_ts', (0, _momentTimezone.default)().format('YYYYMMDDhhmmss'));
  },
  isArrayElementsDuplicated: arr => {
    let sorted_arr = arr.slice().sort(); // You can define the comparing function here. 
    // JS by default uses a crappy string compare.
    // (we use slice to clone the array so the
    // original array won't be modified)
    for (let i = 0; i < sorted_arr.length - 1; i++) {
      if (sorted_arr[i + 1] === sorted_arr[i]) {
        return true;
      }
    }
    return false;
  },
  sortAccountsByType: arr => {
    return arr.slice().sort((a, b) => {
      if (a.type > b.type) return 1;
      if (a.type < b.type) return -1;
      return 0;
    }).sort((a, b) => {
      if (a.status > b.status) return 1;
      if (a.status < b.status) return -1;
      return 0;
    });
  },
  agGridFieldDefFactor: factor => {
    switch (factor) {
      case 5:
        return 4;
      case 4:
        return 3.2;
      case 3:
        return 2.0;
      case 2:
        return 1.4;
      default:
        return 1;
    }
  },
  SortBy: function () {
    let prop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'name';
    let asc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return (a, b) => {
      if (prop) {
        if (a[prop] > b[prop]) return asc ? 1 : -1;
        if (b[prop] > a[prop]) return asc ? -1 : 1;
      } else {
        if (a > b) return asc ? 1 : -1;
        if (b > a) return asc ? -1 : 1;
      }
      return 0;
    };
  },
  consoleWrapper: function () {
    let enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return {
      debug: function () {
        if (enable) global.console.debug(...arguments);
      },
      error: function () {
        if (enable) global.console.error(...arguments);
      },
      warn: function () {
        if (enable) global.console.warn(...arguments);
      },
      info: function () {
        if (enable) global.console.info(...arguments);
      },
      log: function () {
        if (enable) global.console.log(...arguments);
      }
    };
  }
};
var _default = exports.default = Constants;